import { useEffect } from "react";
import LogoWithLanguage from "../../../components/logo-with-language/LogoWithLanguage";
import { useTranslation } from "react-i18next";
import { classNames } from "../../../helpers";
import checkIcon from "../../../assets/svg/check.svg";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import ContainerMd from "../../../components/Layouts/ContainerMd";
import { useNavigationHelpers } from "../../../hooks/useNavigationHelpers";

export default function RecitationRecordingPanel() {
    const [searchParams] = useSearchParams();
    const LocalBasePath = "page.recitationRecordingPanel";
    const { t } = useTranslation("", { keyPrefix: LocalBasePath });
    const { t:button } = useTranslation("", { keyPrefix: 'page.readingRecorder' });
    const navigate = useNavigate();
    const { handleBack } = useNavigationHelpers();
    let apiData = {};

    useEffect(() => {
        apiData = {
            full_name: searchParams.get("full_name"),
            first_name: searchParams.get("first_name"),
            middle_name: searchParams.get("middle_name"),
            last_name: searchParams.get("last_name"),
            phone_number: searchParams.get("phone_number"),
            gender: searchParams.get("gender"),
            program_name: searchParams.get("program_name"),
            telawah_id: searchParams.get("telawah_id"),
            email: searchParams.get("email"),
            timezone: searchParams.get("timezone"),
            submission: searchParams.get("submission"),
        };
    }, []);

    function navigateToRecord(type: string) {
        const queryParams = new URLSearchParams(apiData).toString();
        navigate(`/learner/reading-recorder/${type}?${queryParams}`);
    }
    return (
        <ContainerMd>
            <div className={classNames("w-full   flex flex-col md:bg-white md:p-6 ")}>
                <div className="px-4 mb-36 md:px-0">
                    <div className="flex flex-col items-center justify-between w-full mb-6 md:flex-row">
                        <LogoWithLanguage />
                    </div>
                    <div className="pb-2 border-b border-gray-200">
                        <h1 className="mb-2 text-3xl font-bold text-gray-700 ">
                            {t("readingRecording")}
                        </h1>
                        <p className="text-lg text-gray-500 ">
                            {t("pleaseRecordAnAudioOrPhotographerForYourReading")}
                        </p>
                    </div>
                    <div className="mt-6 text-[#4B5563] font-normal text-lg ">
                        <h3>{t("pleaseTakeIntoAccountTheFollowing")}</h3>
                        <ul className="flex flex-col gap-5 my-5">
                            <li className="flex gap-1.5">
                                <img src={checkIcon} />
                                {t("readAPageFromTheBookOfGod")}
                            </li>
                            <li className="flex gap-1.5">
                                <img src={checkIcon} />
                                {t("prepareYourMushaf")}
                            </li>
                            <li className="flex gap-1.5">
                                <img src={checkIcon} />
                                {t("youCanInspectTheRegisteredClip")}
                            </li>
                        </ul>
                        <h4 className="text-xs text-red-500">
                            {t("theRecordingIsSentToThePurposeOfEvaluationOnly")}
                        </h4>
                    </div>
                </div>

                <div
                    className={classNames(
                        "z-20 px-10 py-4  md:px-0 w-full sticky items-end border-t border-gray-200 bottom-0 bg-white gap-3 flex justify-between "
                    )}
                >
                    <div className="w-full">
                        <button
                            onClick={handleBack}
                            className="px-6 py-2 text-sm text-gray-700 border-2 border-gray-300 rounded-md whitespace-nowrap md:px-4"
                        >
                            {button("back")}
                        </button>
                    </div>
                    <div className="flex flex-col-reverse w-full gap-4 md:flex-row-reverse">
                        <button
                            onClick={() => navigateToRecord("video")}
                            data-cy="next"
                            className="min-w-[230px] flex justify-center flex-shrink-0 px-6 py-2 md:px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-none disabled:bg-gray-400"
                        >
                            {t("voiceAndImageRecording")}
                        </button>
                        <button
                            onClick={() => navigateToRecord("voice")}
                            data-cy="next"
                            className="min-w-[230px] flex justify-center flex-shrink-0 px-6 py-2 md:px-4 border border-[#D1D5DB] shadow-sm text-sm font-medium rounded-md text-[#374151]  bg-white hover:bg-brandblue-700 hover:text-white transition focus:outline-none focus:ring-none disabled:bg-gray-400"
                        >
                            {t("voiceRecordOnly")}
                        </button>
                    </div>
                </div>

                {/* <div
          className={classNames(
            "z-20 px-10 justify-end fixed start-0 end-0 items-end bottom-0 bg-white gap-3 flex  pb-6"
          )}
        >
          <div className="flex justify-end w-full gap-4 py-4 border-t border-gray-200">
            <button
              onClick={() => navigateToRecord("voice")}
              data-cy="next"
              className="flex justify-center flex-shrink-0 px-6 py-2 md:px-4 border border-[#D1D5DB] shadow-sm text-sm font-medium rounded-md text-[#374151]  bg-white hover:bg-brandblue-700 hover:text-white transition focus:outline-none focus:ring-none disabled:bg-gray-400"
            >
              {t("voiceRecordOnly")}
            </button>
            <button
              onClick={() => navigateToRecord("video")}
              data-cy="next"
              className="flex justify-center flex-shrink-0 px-6 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm md:px-4 bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-none disabled:bg-gray-400"
            >
              {t("voiceAndImageRecording")}
            </button>
          </div>
        </div> */}
            </div>
        </ContainerMd>
    );
}
